<div class="course-viewer">
  <button type="button" class="viewer-back" (click)="back()">← {{ 'catalog.back' | translate }}</button>
  <h1 class="viewer-title">{{ courseRef() }}</h1>

  @if (loading()) {
    <div class="viewer-state">{{ 'catalog.loading' | translate }}</div>
  } @else if (error()) {
    <div class="viewer-state error">{{ 'catalog.not_available' | translate }}</div>
  } @else if (chapters().length === 0) {
    <div class="viewer-state">{{ 'catalog.no_chapters' | translate }}</div>
  } @else {
    <media-grid [entities]="chapters()" [mediaOf]="mediaOf" (select)="onSelect($event)">
      <!-- media-card only shows the title when the consumer projects a details
           template (JsonMedia maps the chapter JSON "title" to media.name). -->
      <ng-template #mediaDetails let-media="media">
        <h6 class="chapter-title">{{ media.name }}</h6>
      </ng-template>
    </media-grid>
  }
</div>
